export const GET_ALL_BOOKING_LIST = "GET_ALL_BOOKING_LIST";